<template>
    <div class="terms-of-service nunito">
      <h1>Términos de Servicio</h1>
      <div class="content">
        <section>
          <h2>1. Introducción</h2>
          <p>
            Bienvenido a Lr Pro Marketing Estos términos y condiciones describen las reglas y regulaciones para
            el uso del sitio web de Lr Pro Marketing.
          </p>
        </section>
        <section>
          <h2>2. Propiedad Intelectual</h2>
          <p>
            Todo el contenido, marcas, logotipos, y otros elementos visuales en nuestro sitio web son propiedad de Lr Pro Marketing y sus licenciantes.
          </p>
        </section>
        <section>
          <h2>3. Restricciones</h2>
          <p>
            No debes: Publicar material del sitio web en ningún otro medio. Vender, sublicenciar y/o comercializar
            cualquier material del sitio web.
          </p>
        </section>
        <section>
          <h2>4. Privacidad</h2>
          <p>
            Tu privacidad es muy importante para nosotros. Por favor, lee nuestra <router-link to="/privacy-policy" title="Leer política de privacidad">política de privacidad</router-link> para más
            información.
          </p>
        </section>
        <section>
          <h2>5. Modificaciones de los Términos</h2>
          <p>
            Nos reservamos el derecho de revisar y modificar estos términos en cualquier momento.
          </p>
        </section>
        <section>
          <h2>6. Contacto</h2>
          <p>
            Si tienes alguna pregunta sobre estos términos, por favor contáctanos.
          </p>
        </section>
      </div>
    </div>
</template>

<script>
export default {
  name: 'TermsOfServiceComponent',
};
</script>

<style lang="scss" scoped>
.terms-of-service {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  line-height: 1.6;

  h1 {
    text-align: center;
    margin-bottom: 20px;
    font-size: 2.5rem;
  }

  .content {
    section {
      margin-bottom: 20px;

      h2 {
        font-size: 1.5rem;
        margin-bottom: 10px;
      }

      p {
        font-size: 1rem;
      }
    }
  }
}
</style>